import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18.632 1.94a1.5 1.5 0 0 0-2.121 0l-8.572 8.57a1.5 1.5 0 0 0-.439 1.061V15A1.5 1.5 0 0 0 9 16.5h3.429a1.5 1.5 0 0 0 1.06-.44l8.572-8.57a1.5 1.5 0 0 0 0-2.122zM17.572 3 9 11.571V15h3.429L21 6.429zM3.843 4.584c.214-.214.504-.334.806-.334h5.282a.75.75 0 1 0 0-1.5H4.65a2.64 2.64 0 0 0-2.64 2.639v13.669c0 .678.264 1.41.774 1.92a2.64 2.64 0 0 0 1.866.772h13.714c.7 0 1.37-.278 1.866-.773.51-.51.772-1.241.772-1.92v-5.49a.75.75 0 0 0-1.5 0v5.49c0 .325-.134.66-.333.86a1.14 1.14 0 0 1-.805.333H4.65c-.302 0-.592-.12-.806-.334-.198-.198-.333-.534-.333-.858V5.388c0-.301.12-.59.333-.804",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }